import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SiteServiceManager, ServiceRegistrarPropsExtender } from './siteServiceManager'
import {
	LifeCycle,
	PageServicesManagerSymbol,
	RendererPropsExtenderSym,
	SiteServicesManagerSymbol,
	SiteServicesProviderSymbol,
} from '@wix/thunderbolt-symbols'
import { PageServiceManager, PageServiceManagerDs } from './pageServiceManager'
import { SiteServicesProvider } from './siteServicesProvider'

export const site: ContainerModuleLoader = (bind) => {
	bind(SiteServicesManagerSymbol).to(SiteServiceManager)
	bind(RendererPropsExtenderSym).to(ServiceRegistrarPropsExtender)
	bind(SiteServicesProviderSymbol, LifeCycle.AppWillMountHandler).to(SiteServicesProvider)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(PageServicesManagerSymbol, LifeCycle.PageWillMountHandler).to(PageServiceManager)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(PageServicesManagerSymbol, LifeCycle.PageWillMountHandler).to(PageServiceManagerDs)
}
export const editor: ContainerModuleLoader = (bind) => {
	bind(SiteServicesManagerSymbol).to(SiteServiceManager)
	bind(RendererPropsExtenderSym).to(ServiceRegistrarPropsExtender)
	bind(SiteServicesProviderSymbol, LifeCycle.AppWillMountHandler).to(SiteServicesProvider)
}
